import React, { useState, useEffect } from "react";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import axios from "axios";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import Chip from "@mui/material/Chip";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import RefreshIcon from "@mui/icons-material/Refresh";
import dayjs from "dayjs";
import { formatInTenantTz } from "../../utils/dateUtils";

import {
  Divider,
  Menu,
  TextField,
  useMediaQuery,
  useTheme,
  Typography,
} from "@mui/material";
import { MenuItem } from "@mui/material";
import { Select } from "@mui/material";
import { Grid } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Tooltip from "@mui/material/Tooltip";
import InputAdornment from "@mui/material/InputAdornment";
import Search from "@mui/icons-material/Search";
import DoDisturbIcon from "@mui/icons-material/DoDisturb";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import WhatsappFormDialog from "./WhatsappFormDialog";
import {
  GET_RCS_BOTS,
  GET_RCS_TEMPLATES,
  TEMPLATE_ENDPOINT,
} from "../../config/urls";
import { useAuth } from "../../hooks/AuthProvider";
import { Add, Category, Language, Translate, Tune } from "@mui/icons-material";
import { FilterModal, FilterModalItem } from "../FilterModal";
import { CalendarIcon } from "@mui/x-date-pickers";
import TableFilterButton from "../TableFilterButton";
import TableSearchInput from "../TableSearchInput";
import ButtonOne from "../../common/normal-button";
import ButtonTwo from "../../common/dashboard-button";
import CampaignIcon from "@mui/icons-material/Campaign";
import SyncIcon from "@mui/icons-material/Sync";
import {
  borderColors,
  ColorsConstants,
  grayFontColor,
} from "../../cssUtils/constants";
import { FiberManualRecord as DotIcon } from "@mui/icons-material";
import CustomPagination from "../../common/custom-pagination";
import RCSCampaignTypeModal from "../CampaignManagement/RCSCampaignTypeModal";
import RCSCreateCampaignModal from "../CampaignManagement/RCSCreateCampaignModal";
import typography from "../../cssUtils/typography";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import RCSTemplatePreview from "../../common/RCSTemplatePreview";
import AppDropdown from "../../common/app-dropdown";
import AppTable from "../../common/app-table";
import {
  FILTER_NAMESPACES,
  loadFilters,
  saveFilters,
  clearFilters,
} from "../../utils/filterStorage";

const FILTER_KEY = FILTER_NAMESPACES.RCS_TEMPLATES;
const DEFAULT_RCS_TEMPLATE_FILTERS = {
  status: "",
  searchQuery: "",
  dateRange: [null, null],
  appliedDateRange: [null, null],
};

const columns = [
  { id: "name", label: "Template Name" },
  { id: "template_type", label: "Template Type" },
  { id: "template_use_case", label: "Category" },
  { id: "status", label: "Status" },
  { id: "id", label: "Template ID" },
  { id: "created_at", label: "Created Date" },
  { id: "description", label: "Description" },
  { id: "action", label: "Action" },
];

export default function RCSTemplatesTab({
  refreshKey,
  dateInput,
  setTemplatesNamesData,
  handleCreateTemplateClick,
  setComponent,
  setTemplatesData,
  bots,
  setBots,
  selectedBot: propSelectedBot,
  ...props
}) {
  const [selectedBot, setSelectedBot] = useState(() => {
    if (propSelectedBot) {
      return propSelectedBot.id || propSelectedBot;
    }
    return "";
  });

  useEffect(() => {
    if (propSelectedBot) {
      setSelectedBot(propSelectedBot.id || propSelectedBot);
    }
  }, [propSelectedBot]);

  const { getValidToken } = useAuth();

  // Consolidated filter state (persisted to localStorage)
  const [filters, setFilters] = useState(() => loadFilters(FILTER_KEY, DEFAULT_RCS_TEMPLATE_FILTERS));
  const {
    status: statusFilter,
    searchQuery,
    dateRange,
    appliedDateRange,
  } = filters;
  const updateFilter = (field, value) => setFilters((prev) => ({ ...prev, [field]: value }));

  const [dateError, setDateError] = useState(null);
  const [dateAnchorEl, setDateAnchorEl] = useState(null);
  const [endDatePickerOpen, setEndDatePickerOpen] = useState(false);
  // const [statusFilter, setStatusFilter] = useState("");

  const [charCount, setCharCount] = useState(0);
  const [templatesData, setTemplateData] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState({});

  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: 20,
    serverSidePage: 0,
  });

  const [campaignTypeModalOpen, setCampaignTypeModalOpen] = useState(false);
  const [campaignModalOpen, setCampaignModalOpen] = useState(false);
  const [campaignType, setCampaignType] = useState(null);
  const [campaignName, setCampaignName] = useState("");
  const [campaignDescription, setCampaignDescription] = useState("");
  const [campaignNameError, setCampaignNameError] = useState("");
  const [campaignNameCharCount, setCampaignNameCharCount] = useState(0);
  const [campaignDescCharCount, setCampaignDescCharCount] = useState(0);

  const [previewModalOpen, setPreviewModalOpen] = useState(false);
  const [previewTemplate, setPreviewTemplate] = useState(null);

  const handleOpenPreview = (template) => {
    setPreviewTemplate(template);
    setPreviewModalOpen(true);
  };

  const handleClosePreview = () => {
    setPreviewModalOpen(false);
    setPreviewTemplate(null);
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [templates, setTemplates] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  const fetchBots = async () => {
    setLoading(true);
    setError(null);
    try {
      const headers = {
        "X-Tenant-ID": localStorage.getItem("tenant") || "",
      };
      const response = await axios.get(GET_RCS_BOTS, { headers });

      const botsData = response.data;
      if (!propSelectedBot && botsData.results?.length) {
        setSelectedBot(botsData.results[0].id);
      }
      if (Array.isArray(botsData)) {
        setBots(botsData);
      } else if (botsData && Array.isArray(botsData.results)) {
        setBots(botsData.results);
      } else if (botsData && Array.isArray(botsData.data)) {
        setBots(botsData.data);
      } else if (botsData && typeof botsData === "object") {
        setBots(Object.values(botsData));
      } else {
        setBots([]);
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to fetch bots");
      console.error("Error fetching bots:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleResetFilter = () => {
    setFilters({ ...DEFAULT_RCS_TEMPLATE_FILTERS });
    clearFilters(FILTER_KEY);
    setDateError(null);
    setController((prev) => ({ ...prev, page: 0, serverSidePage: 0 }));
  };

  const fetchTemplates = async () => {
    setLoading(true);
    setError(null);
    try {
      const headers = {
        "X-Tenant-ID": localStorage.getItem("tenant") || "",
      };

      if (!selectedBot) {
        setTemplates([]);
        setTotalCount(0);
        setLoading(false);
        return;
      }

      const params = {
        bot_id: selectedBot,
        limit: controller.rowsPerPage,
        offset: controller.page * controller.rowsPerPage,
      };

      if (searchQuery) {
        params.search = searchQuery;
        params.search_query = searchQuery;
      }
      // Backend expects YYYY-MM-DD for API requests
      if (dateRange[0]) {
        params.from_date = dayjs(dateRange[0]).format("YYYY-MM-DD");
      }
      if (dateRange[1]) {
        params.to_date = dayjs(dateRange[1]).format("YYYY-MM-DD");
      }
      if (statusFilter) {
        params.status_filter = statusFilter;
      }

      const response = await axios.get(GET_RCS_TEMPLATES, {
        headers,
        params: params,
      });

      const isPaginated = response.data && response.data.results !== undefined;
      const templatesData = isPaginated ? response.data.results : response.data;
      const countData = isPaginated
        ? response.data.count
        : templatesData.length;

      setTemplates(templatesData || []);
      setTotalCount(countData || 0);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to fetch templates");
      console.error("Error fetching templates:", err);
    } finally {
      setLoading(false);
    }
  };

  // Local filtering pass
  const filteredTemplates = templates.filter((template) => {
    const searchLower = searchQuery.toLowerCase();
    const matchesSearch =
      !searchQuery ||
      template.name?.toLowerCase().includes(searchLower) ||
      template.description?.toLowerCase().includes(searchLower) ||
      template.template_use_case?.toLowerCase().includes(searchLower);

    let matchesDate = true;
    if (dateRange[0] || dateRange[1]) {
      const templateDate = dayjs(template.created_at);
      const fromDate = dateRange[0] ? dayjs(dateRange[0]).startOf("day") : null;
      const toDate = dateRange[1] ? dayjs(dateRange[1]).endOf("day") : null;

      if (fromDate && templateDate.isBefore(fromDate)) matchesDate = false;
      if (toDate && templateDate.isAfter(toDate)) matchesDate = false;
    }

    const matchesStatus = !statusFilter || template.status === statusFilter;

    return matchesSearch && matchesDate && matchesStatus;
  });

  const handleToDateOpen = () => {
    if (dateRange[0]) setEndDatePickerOpen(true);
  };

  const handleDateRangeCancel = () => {
    setFilters((prev) => ({ ...prev, dateRange: [null, null], appliedDateRange: [null, null] }));
    setDateError(null);
    setController((prev) => ({ ...prev, page: 0, serverSidePage: 0 }));
  };

  const handleDateRangeApply = () => {
    if (dateRange[0] && dateRange[1]) {
      updateFilter("appliedDateRange", [dateRange[0], dateRange[1]]);
      setController((prev) => ({ ...prev, page: 0, serverSidePage: 0 }));
    }
  };

  useEffect(() => {
    saveFilters(FILTER_KEY, filters);
  }, [filters]);

  useEffect(() => {
    fetchBots();
  }, []);

  // Trigger API fetch instantly on select/type with a 500ms debounce
  // Trigger API fetch instantly on select/type with a 500ms debounce
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (selectedBot) {
        fetchTemplates();
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [
    selectedBot,
    controller.page,
    controller.rowsPerPage,
    searchQuery,
    dateRange,
  ]);

  const handleBotChange = (event) => {
    setSelectedBot(event.target.value);
  };

  const handleSearchQueryChange = (event) => {
    if (event.target.value.length > 50) return;
    updateFilter("searchQuery", event.target.value);
    setCharCount(event.target.value.length);
    setController((prev) => ({ ...prev, page: 0, serverSidePage: 0 }));
  };

  const handleChangeRowsPerPage = (event) => {
    setController((prev) => ({
      ...prev,
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
      serverSidePage: 0,
    }));
  };

  const handlePageChange = (event, newPage) => {
    setController((prev) => ({
      ...prev,
      page: newPage,
      serverSidePage: newPage,
    }));
  };

  const handleOpenCampaignModal = () => {
    setCampaignName("");
    setCampaignDescription("");
    setCampaignNameError("");
    setCampaignNameCharCount(0);
    setCampaignDescCharCount(0);
    setCampaignModalOpen(true);
  };

  const handleCloseCampaignTypeModal = () => {
    setCampaignTypeModalOpen(false);
  };

  const handleCloseCampaignModal = () => {
    setCampaignModalOpen(false);
  };

  const handleCampaignNameChange = (e) => {
    const value = e.target.value;
    if (value.length <= 50) {
      setCampaignName(value);
      setCampaignNameCharCount(value.length);
      setCampaignNameError(
        value.trim() === "" ? "Campaign name is required" : "",
      );
    }
  };

  const handleCampaignDescriptionChange = (e) => {
    const value = e.target.value;
    if (value.length <= 250) {
      setCampaignDescription(value);
      setCampaignDescCharCount(value.length);
    }
  };

  const handleCreateCampaign = () => {
    if (!campaignName.trim() && campaignType === "standard") {
      setCampaignNameError("Campaign name is required");
      return;
    }
    setCampaignModalOpen(false);
    const selectedBotData = bots.filter((item) => item?.id === selectedBot);

    props.onNavigate("section_direct_rcs_bot_create", {
      campaignName: campaignName.trim(),
      campaignDescription: campaignDescription.trim(),
      campaignType: campaignType,
      currentView: "broadcast-template",
      template: selectedTemplate,
      bot: selectedBotData[0],
    });
  };

  const handleBroadcastTemplate = (template) => {
    setCampaignTypeModalOpen(true);
    setSelectedTemplate(template);
  };

  return (
    <div>
      {isMobile && (
        <Box sx={{ mb: 2, display: "flex", flexDirection: "column", gap: 2 }}>
          {/* <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <ButtonOne variant="contained" startIcon={<Add />} title="Create" />
          </Box> */}
          <Divider />
          <Box
            sx={{ display: "flex", justifyContent: "space-between", gap: 1 }}
          >
            <TableSearchInput
              searchQuery={searchQuery}
              onSearchChange={handleSearchQueryChange}
              charCount={charCount}
              tooltip="Search by Template Name"
            />
          </Box>
        </Box>
      )}
      <Paper sx={{ width: "100%", overflow: "hidden", boxShadow: "none" }}>
        {!isMobile && (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box
              sx={{
                p: 1,
                bgcolor: "background.paper",
                borderRadius: 1,
                my: 2,
                display: "flex",
                flexWrap: "wrap",
                gap: 1,
              }}
            >
              <Box>
                <TableSearchInput
                  searchQuery={searchQuery}
                  onSearchChange={handleSearchQueryChange}
                  placeholder="Search by Template Name"
                  tooltip="Search by Template Name"
                  charCount={charCount}
                  maxChars={50}
                />
              </Box>
              <Box>
                <AppDropdown
                  fullWidth
                  endIcon={
                    <KeyboardArrowDownOutlinedIcon
                      sx={{ color: grayFontColor }}
                    />
                  }
                  selectedValue={selectedBot}
                  menuItems={bots.map((bot) => ({
                    label: bot.bot_name,
                    value: bot.id,
                  }))}
                  onMenuSelect={(value) =>
                    handleBotChange({ target: { value } })
                  }
                  emptyText="No bots available"
                  loading={loading && bots.length === 0}
                  sx={{ width: "100%", justifyContent: "space-between" }}
                >
                  {selectedBot
                    ? bots.find((b) => b.id === selectedBot)?.bot_name
                    : "Select Bot"}
                </AppDropdown>
              </Box>
              <Box>
                <AppDropdown
                  endIcon={
                    <KeyboardArrowDownOutlinedIcon
                      sx={{ color: grayFontColor }}
                    />
                  }
                  menuItems={[
                    { label: "Approved", value: "APPROVED" },
                    { label: "Rejected", value: "REJECTED" },
                    { label: "Pending", value: "SUBMITTED" },
                  ]}
                  selectedValue={statusFilter}
                  onMenuSelect={(value) => updateFilter("status", value)}
                >
                  {statusFilter
                    ? statusFilter === "SUBMITTED"
                      ? "Pending"
                      : statusFilter.charAt(0) + statusFilter.slice(1).toLowerCase()
                    : "Status"}
                </AppDropdown>
              </Box>
              <Box>
                <AppDropdown
                  endIcon={
                    <KeyboardArrowDownOutlinedIcon
                      sx={{ color: grayFontColor }}
                    />
                  }
                  paperProps={{
                    width: dateAnchorEl
                      ? dateAnchorEl.offsetWidth * 2
                      : undefined,
                    maxWidth: "500px",
                  }}
                  menuContent={(closeMenu) => (
                    <Box sx={{ p: 2 }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                          }}
                        >
                          <Typography sx={{ ...typography.bodyLarge }}>
                            Select date range:
                          </Typography>
                          <Box sx={{ display: "flex", gap: 2 }}>
                            <DatePicker
                              format="DD/MM/YYYY"
                              disableFuture
                              label="Created Date From"
                              value={dateRange[0]}
                              onChange={(newValue) => {
                                updateFilter("dateRange", [newValue, dateRange[1]]);
                                setController((prev) => ({
                                  ...prev,
                                  page: 0,
                                  serverSidePage: 0,
                                }));
                              }}
                              slotProps={{
                                textField: {
                                  size: "small",
                                  sx: {
                                    width: "200px",
                                    "& .MuiInputBase-root": {
                                      height: "40px",
                                    },
                                  },
                                },
                              }}
                            />
                            <DatePicker
                              format="DD/MM/YYYY"
                              disableFuture
                              label="Created Date To"
                              value={dateRange[1]}
                              onChange={(newValue) => {
                                updateFilter("dateRange", [dateRange[0], newValue]);
                                setController((prev) => ({
                                  ...prev,
                                  page: 0,
                                  serverSidePage: 0,
                                }));
                              }}
                              minDate={dateRange[0] || undefined}
                              open={endDatePickerOpen}
                              onOpen={handleToDateOpen}
                              onClose={() => setEndDatePickerOpen(false)}
                              slotProps={{
                                textField: {
                                  error:
                                    (dateRange[1] && !dateRange[0]) ||
                                    dateError,
                                  helperText:
                                    dateRange[1] && !dateRange[0]
                                      ? "Please select Created Date From first"
                                      : dateError,
                                  size: "small",
                                  sx: {
                                    width: "200px",
                                    "& .MuiInputBase-root": {
                                      height: "40px",
                                    },
                                  },
                                },
                              }}
                            />
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                              gap: 1,
                            }}
                          >
                            <ButtonTwo
                              onClick={() => {
                                handleDateRangeCancel();
                                closeMenu();
                              }}
                              variant="outlined"
                            >
                              Cancel
                            </ButtonTwo>
                            <ButtonOne
                              onClick={() => {
                                handleDateRangeApply();
                                closeMenu();
                              }}
                              variant="contained"
                              disabled={!dateRange[0] || !dateRange[1]}
                            >
                              Apply
                            </ButtonOne>
                          </Box>
                        </Box>
                      </LocalizationProvider>
                    </Box>
                  )}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      overflow: "hidden",
                    }}
                  >
                    <Box
                      component="span"
                      sx={{
                        mr: appliedDateRange[0] && appliedDateRange[1] ? 1 : 0,
                        flexShrink: 0,
                      }}
                    >
                      {appliedDateRange[0] && appliedDateRange[1]
                        ? "Date Range:"
                        : "Select Date Range"}
                    </Box>
                    {appliedDateRange[0] && appliedDateRange[1] && (
                      <Chip
                        size="small"
                        onDelete={handleDateRangeCancel}
                        label={`${appliedDateRange[0].format("DD/MM/YYYY")} - ${appliedDateRange[1].format("DD/MM/YYYY")}`}
                        sx={{
                          maxWidth: { sm: 80, md: 200 },
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      />
                    )}
                  </Box>
                </AppDropdown>
              </Box>
              <Box>
                <ButtonTwo
                  title="Reset Filters"
                  onClick={handleResetFilter}
                  sx={{ height: 40 }}
                />
              </Box>
            </Box>
          </LocalizationProvider>
        )}

        <AppTable
          loading={loading}
          emptyMessage="No templates found"
          rows={filteredTemplates}
          rowKey="id"
          count={totalCount}
          page={controller.page}
          rowsPerPage={controller.rowsPerPage}
          rowsPerPageOptions={[20, 50, 100]}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleChangeRowsPerPage}
          columns={[
            {
              id: "name",
              label: "Template Name",
              render: (template) => (
                <Typography
                  sx={{
                    ...typography.bodyLarge,
                    color: ColorsConstants.primaryBlue100,
                    cursor: "pointer",
                    fontWeight: 600,
                    "&:hover": { textDecoration: "underline" },
                  }}
                  onClick={() => handleOpenPreview(template)}
                >
                  {template.name}
                </Typography>
              ),
            },
            {
              id: "template_type",
              label: "Template Type",
              render: (template) => (
                <Typography sx={{ ...typography.bodyLarge }}>
                  {template.template_type
                    ?.replaceAll("_", " ")
                    .replace(/\b\w/g, (char) => char.toUpperCase())}
                </Typography>
              ),
            },
            {
              id: "template_use_case",
              label: "Category",
            },
            {
              id: "status",
              label: "Status",
              render: (template) =>
                template.status === "APPROVED" ? (
                  <Chip
                    label="APPROVED"
                    color="success"
                    size="small"
                    variant="outlined"
                  />
                ) : template.status === "REJECTED" ? (
                  <Chip
                    label="REJECTED"
                    color="error"
                    size="small"
                    variant="outlined"
                  />
                ) : template.status === "SUBMITTED" ? (
                  <Chip
                    label="PENDING"
                    color="warning"
                    size="small"
                    variant="outlined"
                  />
                ) : (
                  <Chip
                    label={template.status}
                    size="small"
                    variant="outlined"
                  />
                ),
            },
            {
              id: "id",
              label: "Template ID",
            },
            {
              id: "created_at",
              label: "Created Date",
              render: (template) => (
                <Typography sx={{ ...typography.bodyLarge }}>
                  {formatInTenantTz(template.created_at, "DD/MM/YYYY")}
                </Typography>
              ),
            },
            {
              id: "description",
              label: "Description",
              minWidth: 250,
              render: (template) =>
                template.description ? (
                  <Tooltip title={template.description} placement="top" arrow>
                    <Box
                      sx={{
                        display: "-webkit-box",
                        WebkitLineClamp: 1,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        cursor: "default",
                        maxWidth: "250px",
                        ...typography.bodyLarge,
                      }}
                    >
                      {template.description}
                    </Box>
                  </Tooltip>
                ) : (
                  <Typography sx={{ ...typography.bodyLarge }}>-</Typography>
                ),
            },
            {
              id: "action",
              label: "Action",
              render: (template) => (
                <>
                  <Tooltip
                    title={
                      template.status === "APPROVED"
                        ? "Broadcast Template"
                        : "Only approved templates can be broadcasted"
                    }
                  >
                    <span>
                      <IconButton
                        disabled={template.status !== "APPROVED"}
                        onClick={() => handleBroadcastTemplate(template)}
                      >
                        <CampaignIcon
                          color={
                            template.status === "APPROVED"
                              ? "inherit"
                              : "disabled"
                          }
                        />
                      </IconButton>
                    </span>
                  </Tooltip>

                  <Tooltip title="Edit Template">
                    <IconButton
                      onClick={() => {
                        setComponent(3);
                        setTemplatesData(template);
                      }}
                    >
                      <EditIcon />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Disable Template">
                    <IconButton>
                      <DoDisturbIcon />
                    </IconButton>
                  </Tooltip>
                </>
              ),
            },
          ]}
        />
      </Paper>

      <RCSCampaignTypeModal
        open={campaignTypeModalOpen}
        onClose={handleCloseCampaignTypeModal}
        campaignType={campaignType}
        setCampaignType={setCampaignType}
        onQuickSelect={() => {
          handleCloseCampaignTypeModal();
          handleCreateCampaign();
        }}
        onStandardSelect={() => {
          handleCloseCampaignTypeModal();
          handleOpenCampaignModal();
        }}
        typography={typography}
      />

      <RCSCreateCampaignModal
        open={campaignModalOpen}
        onClose={handleCloseCampaignModal}
        campaignName={campaignName}
        campaignDescription={campaignDescription}
        onNameChange={handleCampaignNameChange}
        onDescriptionChange={handleCampaignDescriptionChange}
        nameError={campaignNameError}
        nameCharCount={campaignNameCharCount}
        descCharCount={campaignDescCharCount}
        onSubmit={handleCreateCampaign}
      />

      <Dialog
        open={previewModalOpen}
        onClose={handleClosePreview}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: "16px" } }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pb: 1,
          }}
        >
          <span
            style={{ ...typography.h3, color: ColorsConstants.primaryBlue100 }}
          >
            Preview: {previewTemplate?.name}
          </span>
          <IconButton
            onClick={handleClosePreview}
            size="small"
            sx={{ color: grayFontColor }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            display: "flex",
            justifyContent: "center",
            backgroundColor: "#f8f9fa",
            pt: 3,
            pb: 4,
          }}
        >
          <RCSTemplatePreview
            template={previewTemplate}
            bot={bots.find((b) => b.id === selectedBot)}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}
